import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Token } from '../manager/token';
// import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ProjectandpriorityService {
  TokenCls;
  showProjectModal = false;
  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }
  getProjectList(client_Id, Employee_Code):any {
    //  api/inventory-data-upload-download-template/client/{id}
    return this.http.post(environment.ApiUrl + `/api/PNP_Inventory_Bucket_Count_Controller`, {
      "Client_Id": client_Id,
      "Employee_Code": Employee_Code
    }).pipe(map(res => res));
  }

  getAccountsByProject(client_Id, projectName) {
    //  api/inventory-data-upload-download-template/client/{id}
    // const obj = {
    //   Client_ID: client_Id,
    //   Project_Name: projectName
    // }
    return this.http.get(environment.ApiUrl + `/api/agent-pnp-account/${client_Id}?project_name=${projectName}`).pipe(map(res => res));
  }

  getPNPFields(client_Id, inventory_Id, inventory_Log_Id, projectName) {
    if (inventory_Log_Id == "N/A") {
      inventory_Log_Id = 0;
    }
    return this.http.get(environment.ApiUrl + `/api/agent-pnp-fields/${client_Id}/${inventory_Id}/${inventory_Log_Id}?bucket_Name=${projectName}`).pipe(map(res => res));
    // api/agent-fields-PNP/{client_Id}/{inventory_Id}/{inventory_Log_Id}
  }

  updatePNPTime(Client_Id, PNP_Inventory_Id, PNP_Inventory_Log_Id):any {
    const formObj = {
      "Client_Id": Client_Id,
      "Bucket_Name": "PNP",
      "PNP_Inventory_Id": PNP_Inventory_Id,
      "Old_PNP_Inventory_Log_Id": PNP_Inventory_Log_Id,
      "Insert_Log": true
    }
    return this.http.put(environment.ApiUrl + '/api/agent-pnp-time', formObj).pipe(map(res => res));
  }
  getLocalAccount():any {
    const result = sessionStorage.getItem('pnpAccounts');
    if (result != undefined && result.length > 0) {
      return JSON.parse(result);
    }
    return [];
  }

  setLocalAccount(accountList):any {
    sessionStorage.setItem('pnpAccounts', JSON.stringify(accountList));
  }

  removeLocalAccount():any {
    sessionStorage.removeItem('pnpAccounts');
  }

  submitPNPForm(formObj) {
    // /api/agent-pnp-fields
    return this.http.put(environment.ApiUrl + '/api/agent-pnp-fields', formObj).pipe(map(res => res));
  }

  getClientProjectList(client_Id) {
    return this.http.get(environment.ApiUrl + `/api/PNP_Module_Name/${client_Id}`).pipe(map(res => res));
  }
  addProject(formObj) {
    // /api/agent-pnp-fields
    return this.http.post(environment.ApiUrl + '/api/PNP_Module_Name', formObj).pipe(map(res => res));
  }

  deActivateProject(formObj) {
    // /api/agent-pnp-fields
    return this.http.put(environment.ApiUrl + '/api/PNP_Module_Name_Deactive', formObj).pipe(map(res => res));
  }

  getEmployeesByModule(Client_Id):any {
    return this.http.get(environment.ApiUrl + `/api/get-Project-employee/${Client_Id}`).pipe(map(res => res));
  }

  getModulesByEmployee(Client_Id):any {
    return this.http.get(environment.ApiUrl + `/api/get-employee-Project/${Client_Id}`).pipe(map(res => res));
  }
  deAllocateByAgent(formBody):any {
    return this.http.put(environment.ApiUrl + `/api/pnp-deallocate-by-agent`, formBody).pipe(map(res => res));
  }

  deAllocateByModule(formBody):any {
    return this.http.put(environment.ApiUrl + `/api/pnp-deallocate-by-project`, formBody).pipe(map(res => res));
  }

  getProjectListByClientID(Client_Id):any {
    // /api/PNP-report-ProjectName/9132
    return this.http.get(environment.ApiUrl + `/api/PNP-report-ProjectName/${Client_Id}`).pipe(map(res => res));
  }

  getPNPReport(formBody):any {
    return this.http.post(environment.ApiUrl + `/api/PNP-report`, formBody).pipe(map(res => res));
    // api/PNP-report
  }

  getPNPProjectList(query):any {
    return this.http.get(environment.ApiUrl + query).pipe(map(res => res));
    // api/PNP-Dashboard-Active/Client/{id}
  }

  deactivateProjectByName(Client_Id, Project_Name):any {
    // console.log('deactivateProjectByName(projectObj) : ', Client_Id, Project_Name);
    // http://172.30.52.25:1001/api/deactivate-project
    return this.http.put(environment.ApiUrl + `/api/deactivate-project`, { "Client_Id": Client_Id, "Project_Name": Project_Name }).pipe(map(res => res));
  }

  getProjectListCount(Client_Id, Project_Name):any {
    const obj = {
      Client_ID: Client_Id,
      Project_Name: Project_Name
    }
    return this.http.post(environment.ApiUrl + `/api/pnp-dashboard-allocated-count`, obj).pipe(map(res => res));
  }

  getEmployeesAllocatedToProject(clientId, projectName, employeeId):any {
    return this.http.get(environment.ApiUrl + `/api/get-all-employee-by-project/client/${clientId}/${projectName}/${employeeId}`).pipe(map(res => res));
  }

  // /api/reallocate-pnp-account
  reallocateProject(body):any {
    // console.log('deactivateProjectByName(projectObj) : ', Client_Id, Project_Name);
    // http://172.30.52.25:1001/api/deactivate-project
    return this.http.put(environment.ApiUrl + `/api/reallocate-pnp-account`, body).pipe(map(res => res));
  }
  getEmployeesForProject(clientId, projectName):any {
    const obj = {
      Client_ID: clientId,
      Project_Name: projectName
    }
    return this.http.post(environment.ApiUrl + `/api/get-agents-for-client`, obj).pipe(map(res => res));
  }

  addAgentToProject(body):any {
    // http://172.30.52.25:1001/api/assign-agent-to-project
    return this.http.put(environment.ApiUrl + `/api/assign-agent-to-project`, body).pipe(map(res => res));
  }

  InsertEndTimeOfPNPInventory(formobj):any {
    return this.http.post(environment.ApiUrl + '/api/agent-pnp-time', formobj)
  }

  GetReportDownload(formBody):any {
    return this.http.post(environment.ApiUrl + `/api/PNP-report-download`, formBody,  { responseType: 'blob'}).pipe(map(res =>
      { return {
          filename: 'PNP Report.xlsx',
          data: res
      };
    }));
  }
}
